import axios from "axios";
import { API } from "../config/AppConfig";
import { UPLOAD_CHART, SUBMIT_UPLOADED_CHART, DELETE_CHART, GET_CLIENT_USER, ATTACH_FILES_TO_CHART, BULK_DELETE_CHART_UPLOADS, VALIDATE_BATCH_NAME, GET_CLIENT_SPECIALTIES_PROVIDERS_MAP } from "../constants/Endpoints";
import { ACCESS_TOKEN } from "../constants/PreferenceKeys";

class ChartUploadRepository {

  async uploadCharts(formData, onUploadProgress) {
    const token = localStorage.getItem(ACCESS_TOKEN)
    const response = await axios.post(
      UPLOAD_CHART,
      formData,
      {
        headers: {
          Authorization: token,
        },
        onUploadProgress,
      },
    );
    // const response = await API.post(UPLOAD_CHART, {
    //   body: payload
    // });
    return response;
  }

  async submitUploadedCharts(payload) {
    const response = await API.post(SUBMIT_UPLOADED_CHART, { body: payload })
    return response;
  }
  async deleteChart(fileId) {
    const response = await API.delete(DELETE_CHART, {
      pathParams: { fileId }
    });
    return response;
  }

  async bulkDeleteChartUpload(payload) {
    const response = await API.post(BULK_DELETE_CHART_UPLOADS, {
      body: payload
    });
    return response;
  }
  async getClientUsers() {
    const response = await API.get(GET_CLIENT_USER);
    return response;
  }

  async getClientSpecialtiesProvidersMap(queryParams) {
    const response = await API.get(GET_CLIENT_SPECIALTIES_PROVIDERS_MAP, {
      queryParams
    });
    return response;
  }

  async validateBatchName(queryParams) {
    const response = await API.get(VALIDATE_BATCH_NAME, {
      queryParams
    });

    return response;
  }

  async attachFiles(chartId, formData, onUploadProgress) {
    const token = localStorage.getItem(ACCESS_TOKEN)
    const url = ATTACH_FILES_TO_CHART.replace(':chartId', chartId)
    const response = await axios.post(
      url,
      formData,
      {
        headers: {
          Authorization: token,
        },
        onUploadProgress,
      },
    );
    return response;
  }
}

const chartUploadRepository = new ChartUploadRepository();
export default chartUploadRepository;